import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin, Table } from "antd";
import Grid from "@mui/material/Grid";
import TitleValue from "../seeker/TitleValue";
import { fetchExpertWiseCuration, fetchUsers_demoted } from "../../../../API/api";
import CountUp from "react-countup";
import { Paper } from "@mui/material";
import styles from "./ExpertOverview.module.css";
import CurationStatusBreakdownExpertOverview from "../../../GraphComponent/CurationStatusBreakdownExpertOverview";
import VizHeader from "../../../VizHeader/VizHeader";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from '../../../../Action/index';
import { render } from "@testing-library/react";

export default function ExpertCuration() {
  const [Category, setCategory] = useState("High");
  const [order, setOrder] = useState("desc");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { crossnavigationExpertCuration, crossnavigationExpertCurationCurated } = bindActionCreators(Actions, dispatch);
  const getCurationLevel = (key) => {
    let arr = [
      { name: '1', value: 'High', label: 'High' },
      { name: '2', value: 'Medium', label: 'Medium' },
      { name: '3', value: 'Low', label: 'Low' },
      { name: '4', value: 'Curated', label: 'Curated' },
    ]
    let obj = arr.find(x => x.value === key);
    return obj;
  }
  const crossNavigation = (name, status) => {
    // console.log("cross", name, status)
    if (status !== "Curated") {
      fetchUsers_demoted(name.Expert).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          // console.log(res.data.data.users[0]);
          crossnavigationExpertCuration({ email: [res.data.data.users[0]], curation: [getCurationLevel(status)] });
          // navigate(`/cmHome/expertRecords/`);
          navigate(`/cmHome/expertResponses/`);
        }
      })
    }
    else {
      fetchUsers_demoted(name.Expert).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          // console.log(res.data.data.users[0]);
          crossnavigationExpertCurationCurated({
            email: [res.data.data.users[0]], cs: [
              {
                "name": "curated",
                "value": "Curated",
                "label": "Curated"
              }
            ]
          });
          // navigate(`/cmHome/expertRecords/`);
          navigate(`/cmHome/expertResponses/`);
        }
      })
    }

    return;
  }
  const columnsData = [
    {
      title: TitleValue("Expert"),
      dataIndex: "Expert",
      align: "left",
      render: (_, raw) => (
        <>
          <span style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
          }}>
            {raw.Expert}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("High"),
      dataIndex: "High",
      align: "center",
      sorter: true,
      defaultSortOrder: "descend",

      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              cursor: 'pointer'
            }}
            onClick={() => {
              crossNavigation(raw, "High");
            }}
          >
            {raw.High}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Medium"),
      dataIndex: "Medium",
      sorter: true,
      align: "center",

      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              cursor: 'pointer'
            }}
            onClick={() => {
              crossNavigation(raw, "Medium");
            }}
          >
            <CountUp end={raw.Medium} />
            {/* {raw.Medium} */}
          </span>
        </>
      ),
    },

    {
      title: TitleValue("Low"),
      dataIndex: "Low",
      align: "center",
      sorter: true,

      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              cursor: 'pointer'
            }}
            onClick={() => {
              crossNavigation(raw, "Low");
            }}
          >
            <CountUp end={raw.Low} duration={3.75} />
            {/* {raw.Low} */}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Curated"),
      dataIndex: "Curated",
      align: "center",
      sorter: true,
      // render: (_, raw) => console.log("raw", raw)
      render: (_, raw) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              cursor: 'pointer'
            }}
            onClick={() => {
              crossNavigation(raw, "Curated");
            }}
          >
            <CountUp end={raw.Curated} duration={3.75} />
            {/* {raw.Low} */}
          </span>
        </>
      ),
    },
  ];
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const handleSortModelChange = React.useCallback(
    (pagination, filters, sorter, extra) => {
      const { field, order } = sorter;

      let orderVal = order === "ascend" ? "Asc" : "Desc";
      // setFilterValue(value);
      setCategory(field);
      setOrder(orderVal);
    },
    []
  );
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );

  React.useEffect(() => {
    if (check !== "") {
      setLoading(true);
      fetchExpertWiseCuration(
        geoLevelId,
        geoLevelValue,
        domainId,
        Category,
        order
      ).then((res) => {
        if (res === undefined) return;
        setLoading(false);
        if (res?.data?.data !== undefined) {
          setData(res?.data?.data);
        }
      });
    }
  }, [geoLevelId, geoLevelValue, domainId, Category, order, length, check]);

  const rows =
    data &&
    Object.entries(data).map(([name, riskLevels]) => ({
      id: name,
      Expert: name,
      High: riskLevels.High === undefined ? 0 : riskLevels?.High,
      Medium: riskLevels.Medium === undefined ? 0 : riskLevels.Medium,
      Low: riskLevels.Low === undefined ? 0 : riskLevels.Low,
      Curated: riskLevels.Curated === undefined ? 0 : riskLevels.Curated,
    }));

  return (
    <>
      {rows && (
        <>
          {" "}
          <div className={styles.ExpertOutline}>
            <Grid container spacing={2} xs={12}>
              <Grid item lg={6} xl={6} xs={12} sm={12} md={12}>
                <Paper>
                  <Spin
                    spinning={loading}
                    style={{ width: "100%", padding: "30px" }}
                  >
                    {" "}
                    <Paper>
                      <div
                        style={{
                          textAlign: "center",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <span>
                          <VizHeader isBold={true} type={4}>
                            Expert Curation
                          </VizHeader>
                        </span>
                      </div>
                      <Table
                        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}

                        showSorterTooltip={false}
                        columns={columnsData}
                        dataSource={rows}
                        style={{
                          boxShadow: "7px 7px 20px lightgrey",
                          fontSize: "18px",
                          borderRadius: "4px",
                          height: "392px",
                          // width: "632px",
                        }}
                        pagination={false}
                        onChange={handleSortModelChange}
                        scroll={{
                          y: 330,
                        }}
                        footer={null}
                      />
                    </Paper>
                  </Spin>
                </Paper>
              </Grid>
              <Grid
                item
                lg={6}
                xl={6}
                style={{ width: "100%", height: "442px" }}
              >
                <Spin
                  spinning={loading}
                  style={{ width: "100%", padding: "30px" }}
                >
                  {" "}
                  <Paper>
                    <CurationStatusBreakdownExpertOverview />
                  </Paper>
                </Spin>
              </Grid>
            </Grid>
          </div>
          <div style={{ paddingTop: '15px', paddingBottom: '15px' }}></div>
        </>
      )}
    </>
  );
}
